// pages/PostRealEstate/PostRealEstateForm.js
import PostRealEstateForm from "../../../components/pages/PostRealEstate/PostRealEstateForm";
import { usePostProperty } from "../../../hooks/pages/property/usePostProperty";

export default function PostProperty() {
  const props = usePostProperty();

  return <PostRealEstateForm {...props} />;
}